<template>
    <el-form ref="orgForm" class="apple_org" label-position="left" v-loading="editLoading" :model="formItem" :rules="rules" label-width="190px">
        <div class="create_list">
            <div class="create_title">Campaign Group</div>
            <el-form-item label="Campaign Group：" prop="org_id">
                <el-select
                    popper-class="select-option-long-text-wrap"
                    v-model="formItem.org_id"
                    ref="select_org_id"
                    filterable
                    reserve-keyword
                    @change="changeSelect('org_id',$event)"
                    :loading="remoteOrgLoading"
                    :disabled="isEdit"
                    class="width400"
                    placeholder="Enter campaign group ID or name keyword to search">
                    <el-option
                        v-for="item in orgList"
                        :key="item.value"
                        :label="item.label+'【'+item.value+'】'"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </div>
        <div class="create_list" v-if="!!formItem.org_id||isEdit">
            <div class="create_title">Basic Information</div>
            <el-form-item label="Promoted App：" prop="app_id" class="relative">
                <span v-if="!!formItem.app_id&&!isEdit" class="remove-app-btn" @click="removeApp">x</span>
                <el-input v-model="appInput" placeholder="Please enter the app name or ID keyword to search" :readonly="!!formItem.app_id" :disabled="isEdit" @input="appInputChange" @keyup.enter.native.prevent.stop="searchApp" class="width400">
                    <el-button slot="append" type="primary" @click.stop="searchApp" class="ml10 width80" :loading="remoteAppLoading" :disabled="!!formItem.app_id||isEdit" plain>Search</el-button>
                </el-input>
                <span class="ml20 text-color-gray font12px" v-if="!isEdit">If the required app does not appear after searching, please check whether the app is already linked to the associated campaign group.</span>

                <p class="mt6 text-color-error font12px" v-if="appErrTxt">{{appErrTxt}}</p>

                <el-popover
                    :value="appPopover"
                    placement="bottom-start"
                    width="400"
                    trigger="manual">
                    <span slot="reference" class="app-reference"></span>
                    <div class="app-search-list" >
                        <ul v-loading="remoteAppLoading" :style="{minHeight:remoteAppLoading?'50px':'10px'}">
                            <li class="pointer" v-for="item in appList" :key="item.value" @click="checkApp(item)">{{item.label}}【{{item.value}}】</li>
                            <li class="tac text-color-gray" v-if="appList.length<=0&&!remoteAppLoading">No matching products</li>
                        </ul>
                    </div>
                </el-popover>


                <!--<el-select
                    popper-class="select-option-long-text-wrap"
                    v-model="formItem.app_id"
                    ref="select_app_id"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteAppMethod"
                    @change="changeSelect('app_id',$event)"
                    :loading="remoteAppLoading"
                    :disabled="isEdit"
                    class="width400"
                    no-data-text="No matching products"
                    no-match-text="No matching products"
                    placeholder="请输入完整的 AppID搜索查询">
                    <el-option
                        v-for="item in appList"
                        :key="item.value"
                        :label="item.label+'-'+item.value"
                        :value="item.value">
                    </el-option>
                </el-select>-->
            </el-form-item>

            <el-form-item label="Ad Placement：" prop="supply_source">
                <SupplyCard class="mt10" :options="supplySourceOptions" :loading="appEligibilityLoading" :disabled="isEdit" :value="formItem.supply_source" @change="changeSupplySource"/>
            </el-form-item>

            <el-form-item label="Country or Region：" prop="countries_or_regions">
                <el-tooltip placement="top" :disabled="!!formItem.app_id&&!!formItem.supply_source">
                    <div slot="content">
                        <span v-if="!formItem.app_id">Please select an app first</span>
                        <span v-else>Please select an ad placement first</span>
                    </div>
                    <el-select
                        v-model="formItem.countries_or_regions"
                        ref="select_countries_or_regions"
                        :disabled="!formItem.app_id||!formItem.supply_source"
                        filterable
                        multiple
                        reserve-keyword
                        class="width400"
                        placeholder="Enter the name of the country or region to search">
                        <el-option
                            v-for="item in countryList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-tooltip>
            </el-form-item>

            <el-form-item prop="daily_budget" class="relative">
                <span slot="label">
                    <el-tooltip placement="top">
                      <div slot="content" style="max-width: 300px;">
                          <p class="mb10">Daily budget is the average amount you want to spend per day on a campaign over the course of a month. Your monthly spend will not exceed the daily budget multiplied by the average number of days in a calendar month. On days with more opportunities for downloads, your spend may exceed your daily budget. Your campaign will continue spending monthly based on the daily budget unless you pause, remove the campaign, or set an end date. If you set an end date, your total spend will not exceed the total number of campaign days multiplied by the daily budget. You can adjust the daily budget at any time.</p>
                      </div>
                      <span class="tal">Daily Budget <i class="el-icon-question pointer" style="text-indent: 0;"></i> ：</span>
                    </el-tooltip>
                </span>
                <el-input v-model="formItem.daily_budget" @input="handleDailyBudgetInput" placeholder="Please enter a daily budget amount" class="width400"></el-input>
                <span class="normal-text ml10">{{orgConfig.currency}}</span>

                <span v-if="+formItem.daily_budget>10000&&+formItem.daily_budget>+avgCampaignDailyBudget" class="daily-budget-tips-text text-color-error font12px ml20">The entered daily budget is greater than or equal to 10,000 {{orgConfig.currency}}，and exceeds the account's average daily budget by {{dailyBudgetDiff}} （{{dailyBudgetRate}}%）,Please verify!</span>
                <span v-else-if="+formItem.daily_budget>+avgCampaignDailyBudget&&avgCampaignDailyBudget>0" class="daily-budget-tips-text text-color-error font12px ml20">The entered daily budget exceeds the account's average daily budget by  {{dailyBudgetDiff}} {{orgConfig.currency}}（{{dailyBudgetRate}}%）,Please verify!</span>
                <span v-else-if="+formItem.daily_budget>10000" class="daily-budget-tips-text text-color-error font12px ml20">The entered daily budget is greater than or equal to 10,000  {{orgConfig.currency}}, Please verify!</span>

            </el-form-item>

            <el-form-item label="Campaign Name：" prop="campaign_name">
                <el-input v-model="formItem.campaign_name" :maxlength="200" placeholder="Up to 200 characters. Special characters are not allowed." class="width400"></el-input>
                <span class="normal-text ml10">{{formItem.campaign_name.length}} / 200</span>
            </el-form-item>
        </div>

        <div class="create_list invoicing_options" v-if="!!formItem.org_id">
            <div class="create_title">Campaign Duration</div>
            <el-form-item label=" Campaign Dates：" prop="time_zone" class="label-required">
                <el-radio-group v-model="startEndDateType">
                    <el-radio-button label="1">
                        <span class="inline-block" style="width:130px;">Long-term Campaign</span>
                    </el-radio-button>
                    <el-radio-button label="2">
                        <span class="inline-block" style="width:160px;">Specify Start and End Dates</span>
                    </el-radio-button>
                </el-radio-group>
                <span class="font12px ml20 text-color-gray" v-if="formItem.time_zone=='Asia/Shanghai'">Time Zone - Shanghai</span>
                <span class="font12px ml20 text-color-gray" v-else-if="formItem.time_zone=='UTC'">Time Zone - UTC</span>
                <!--<el-select v-model="formItem.time_zone" :disabled="isEdit" placeholder="Please select" class="ml10" style="width: 106px;" size="mini">-->
                    <!--<el-option label="时区-上海" value="Asia/Shanghai">时区-上海</el-option>-->
                    <!--<el-option label="时区-UTC" value="UTC">时区-UTC</el-option>-->
                <!--</el-select>-->
                <!--<span class="text-color-gray font12px ml10">您可按照选择的时区直接设置投放日期&时间，无需再次转化时区</span>-->
            </el-form-item>
            <el-form-item label="" prop="start_time">
                <span class="mr20 normal-text">Start Date：</span>
                <el-date-picker
                    :disabled="isEdit"
                    style="width: 136px;"
                    size="mini"
                    v-model="formItem.startDate"
                    :picker-options="startPickerOptions"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="Select a Date">
                </el-date-picker>
                <el-time-picker
                    :disabled="isEdit"
                    class="ml10"
                    style="width: 130px;"
                    size="mini"
                    v-model="formItem.startTime"
                    value-format="HH:mm"
                    format="HH:mm"
                    :picker-options="{format:'HH:mm'}"
                    placeholder="Select a Time">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="" prop="end_time" v-if="startEndDateType=='2'">
                <span class="mr20 normal-text">End Date：</span>
                <el-date-picker
                    style="width: 136px;"
                    size="mini"
                    v-model="formItem.endDate"
                    :picker-options="endPickerOptions"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="Select a Date">
                </el-date-picker>
                <el-time-picker
                    class="ml10"
                    style="width: 130px;"
                    size="mini"
                    v-model="formItem.endTime"
                    value-format="HH:mm"
                    format="HH:mm"
                    :picker-options="{format:'HH:mm'}"
                    placeholder="Select a Time">
                </el-time-picker>
            </el-form-item>
        </div>

        <div class="create_list" v-if="!!formItem.org_id&&formItem.supply_source=='APPSTORE_SEARCH_RESULTS'&&!isEdit">
            <div class="create_title">Keywords</div>
            <el-form-item label="Add negative keyword：" prop="negative_keyword">
                     <span slot="label">
                    <el-tooltip placement="top">
                      <div slot="content" style="max-width: 300px;">
                          "Negative keywords prevent your ad from appearing in search results for those terms.
For example, if you add 'free' as a negative keyword, your ad will not appear in searches using the term 'free.' The negative keywords you add only apply to this ad group. Set negative keywords at the campaign level to apply them to all ad groups."
                      </div>
                      <span>Add negative keyword<i class="el-icon-question" style="text-indent: 2px;"></i> :</span>
                    </el-tooltip>
                </span>

                <el-link type="primary" :underline="false" @click="showNegativeKeywordModal">Click to Add</el-link>
                <span class="normal-text ml10">（ {{formItem.negative_keyword.length}}  campaign negative keywords added）</span>

                <span v-if="!isEdit" class="text-color-error pointer font12px ml20" @click="clearNegativeKeyword">Clear</span>
            </el-form-item>
        </div>

        <div class="create_list invoicing_options" v-if="orgConfig.invoicing_options">
            <div class="create_title">Billing Information</div>

            <el-form-item label="Billing Options：" class="label-required">
                <el-radio-group value="1">
                    <el-radio-button label="1">
                        <span class="inline-block" style="width: 100px;">Standard Order</span>
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="Advertiser or Product：" prop="client_name" class="label-required">
                <el-input v-model="formItem.client_name" placeholder="Please Enter Content" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="Order Number：" prop="order_number" class="label-required">
                <el-input v-model="formItem.order_number" placeholder="Please Enter Content" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="Primary Contact Name：" prop="buyer_name" class="label-required">
                <el-input v-model="formItem.buyer_name" placeholder="Please Enter Content" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="Primary Contact Email：" prop="buyer_email" class="label-required">
                <el-input v-model="formItem.buyer_email" placeholder="Please Enter Content" class="width400"></el-input>
            </el-form-item>
            <el-form-item label="Billing Contact Email：" prop="billing_contact_email" class="label-required">
                <el-input v-model="formItem.billing_contact_email" placeholder="Please Enter Content" class="width400"></el-input>
            </el-form-item>
        </div>

        <NegativeKeywordModal
            ref="negativeKeywordModal"
            action-type="campaignAddNegativeKeyword"
            :action-rows="formItem.negative_keyword"
            :form-data="actionRowData"
            @save="saveNegativeKeyword"/>

        <el-dialog
            :title="null"
            :visible.sync="dialogVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
            </div>
        </el-dialog>
    </el-form>
</template>
<script>
    import {mapGetters} from 'vuex';
    import API from '@/api/marketManage/apple/index-en';
    import SupplyCard from '../components/supplyCard';
    import NegativeKeywordModal from '../keywords/modal/negativeKeywordModal';
    import {
        get_create_ad_err_html,
        get_err_info,
        get_flag_single_post_html,
        get_flag_suc_html,
        get_flag_single_err_html,
        get_flag_mul_err_html
    } from "../components/getFlagHtml.js";
    import {validEmoji} from '@/utils/validate'
    export default {
        name: 'CreateAdOrg',
        components:{
            SupplyCard,
            NegativeKeywordModal,
        },
        props: ['org'],
        data() {
            let _this = this;

            const campNameDailyBudget = (rule, value, callback) =>{
                /* 长期投放：仅设置开始日期 */
                if(+value<0.01){
                    callback(new Error('The daily budget cannot be less than 0.01'));
                }else{
                    callback();
                }
            };

            const campNameValid = async (rule, value, callback) =>{
                await API.getPromotionCampaignName({
                    org_id:_this.formItem.org_id,
                    campaign_name:_this.formItem.campaign_name,
                    campaign_id:_this.isEdit?_this.formItem.campaign_id:'',
                }).then(() => {
                    callback();
                },err=>{
                    callback(new Error(err.info||'Validation failed!'));
                });
            };

            const startTimeValid = (rule, value, callback) =>{
                /* 长期投放：仅设置开始日期 */
                if(!_this.formItem.startDate||!_this.formItem.startTime){
                    callback(new Error('Please set the start time for the ad'));
                }else{
                    callback();
                }
            };

            const endTimeValid = (rule, value, callback) =>{
                if(_this.startEndDateType=='1'){
                    /* 长期投放：仅设置开始日期 */
                    callback();
                }else if(_this.startEndDateType=='2'){
                    /* 指定开始日期和结束日期 */
                    if(!_this.formItem.startDate||!_this.formItem.startTime){
                        callback(new Error('Please set an start date for the campaign'));
                    }else if(!_this.formItem.endDate||!_this.formItem.endTime){
                        callback(new Error('Please set an end date for the campaign'));
                    }if(new Date(_this.formItem.startDate+' '+_this.formItem.startTime).getTime()>=new Date(_this.formItem.endDate+' '+_this.formItem.endTime).getTime()){
                        callback(new Error('The end time of placement must be later than the start time'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            const invoiceValid = (rule, value, callback) =>{
                if(_this.orgConfig.invoicing_options){
                    let reg = /(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g;
                    if(!value){
                        callback(new Error('Please Enter Content'));
                    }else if(validEmoji(value)){
                        callback(new Error('Emojis are not supported'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };


            return {
                formItem:{
                    org_id:'',
                    app_id:'',
                    app_name:'',
                    supply_source:'',   //投放位置
                    countries_or_regions:[],   //国家或地区
                    daily_budget:'',   //每日预算
                    campaign_name:'',   //广告系列名称
                    time_zone:'',       //
                    negative_keyword:[],
                    client_name:'',     // 广告主或产品
                    order_number:'',     // 订单号
                    buyer_name:'',     // 主要联系人姓名
                    buyer_email:'',     // 主要联系人邮箱
                    billing_contact_email:'',     // 结算联系人邮箱
                    startTime:'00:00',
                    startDate:'',
                    endTime:'',
                    endDate:'',
                },
                orgList:[],
                remoteOrgLoading:false,
                appList:[],
                remoteAppLoading:false,
                startEndDateType:'1',   // 1长期 2-指定开始结束日期

                countryList:[],
                remoteCountryLoading:false,
                supplySourceOptions:[
                    {
                        title:'Today Tab',
                        name:'APPSTORE_TODAY_TAB',
                        desc:'Reach users when they visit the App Store to discover apps. Your ad will be fully displayed on the homepage',
                        disabled:true,
                        popTip:'Please select an app first',
                    },
                    {
                        title:'Search Tab',
                        name:'APPSTORE_SEARCH_TAB',
                        desc:'Attract users before they search for apps to download. Your ad will appear at the top of the suggested apps list.',
                        disabled:true,
                        popTip:'Please select an app first',
                    },
                    {
                        title:'Search Results',
                        name:'APPSTORE_SEARCH_RESULTS',
                        desc:'Engage users as they search for apps to download. Your ad will appear at the top of relevant results when users perform a search.',
                        disabled:true,
                        popTip:'Please select an app first',
                    },
                    {
                        title:'Product Page',
                        name:'APPSTORE_PRODUCT_PAGES_BROWSE',
                        desc:'Attract users as they browse apps. Your ad will display to users scrolling to the bottom of relevant product pages, positioned at the top of the "You Might Also Like" list.',
                        disabled:true,
                        popTip:'Please select an app first',
                    },
                ],
                appEligibility:{},
                appEligibilityLoading:false,
                avgCampaignDailyBudget:0,
                startPickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        return time.getTime() < Date.now()-1000*60*60*24*2;
                    },
                },
                endPickerOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time) {
                        let startDate = new Date(_this.formItem.startDate+' '+(_this.formItem.startTime||'00')+':00');
                        return time.getTime() < startDate.getTime();
                    },
                },

                oldSelectVal:{
                    org_id:'',
                    app_id:'',
                },
                rules:{
                    org_id:[
                        { required: true, message: 'Please select an associated campaign group', trigger: 'change' },
                    ],
                    app_id:[
                        { required: true, message: 'Please search and select the app to promote', trigger:'change'},
                    ],
                    supply_source:[
                        { required: true, message: 'Please select the ad placement location', trigger: ['blur','change'] },
                    ],
                    countries_or_regions:[
                        { required: true, message: 'Please select a country or region', trigger: 'change' },
                    ],
                    daily_budget:[
                        { required: true, message: 'Please enter a daily budget', trigger: 'blur' },
                        { validator: campNameDailyBudget, trigger: 'blur' },
                    ],
                    campaign_name:[
                        { required: true, message: 'Please select a campaign name', trigger: 'blur' },
                        { validator: campNameValid, trigger: 'blur' },
                    ],
                    // time_zone:[
                    //     { required: true, message: '请选择时区', trigger:  ['blur','change'] },
                    // ],
                    start_time:[
                        { validator: startTimeValid, trigger: 'blur' },
                    ],
                    end_time:[
                        { validator: endTimeValid, trigger: 'blur' },
                    ],
                    client_name:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    order_number:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    buyer_name:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    buyer_email:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                    billing_contact_email:[
                        { validator: invoiceValid, trigger: 'blur' },
                    ],
                },
                orgConfig:{
                    currency:'',    // 货币
                    invoicing_options:null,     // 是否有结算选项
                },
                orgName:'',
                editLoading:false,
                dialogVisible: false,   //各种错误提示
                dialogTypeTitle: '',
                // apple_create_type: '',

                appInput:'',
                appErrTxt:'',
                appPopover:false,
            }
        },
        computed:{
            ...mapGetters(['name','email','apple_create_type','cur_tab_page']),
            actionRowData(){
                return {
                    org_id:this.formItem.org_id,
                    org_name:this.orgName,
                }
            },
            dailyBudgetRate(){
                let avgVal = +this.avgCampaignDailyBudget;
                let curVal = +this.formItem.daily_budget;
                if(avgVal==0) return 0;
                return curVal>avgVal?((curVal-avgVal)/avgVal*100).toFixed(2):'';
            },
            dailyBudgetDiff(){
                let diff = this.formItem.daily_budget-this.avgCampaignDailyBudget;
                return (diff).toFixed(2);
            },
            isEdit(){
                return this.apple_create_type=='editOrg';
            },
            // res_org_item(){
            //     return this.orgList.filter(item=>item.value == this.formItem.org_id).map(item=>{
            //         return {
            //             org_id:item.value,
            //             org_name:item.label,
            //         }
            //     });
            // },
        },
        watch:{
            org: {
                handler(newVal, oldVal) {
                    let newList = (newVal||{}).list||[];
                    if(newList.length != 0 && !this.isEdit) {
                        this.orgList = newVal.list
                        this.formItem.org_id = newVal['id'].toString()
                        if(this.formItem.org_id != '') {
                            this.getOrgConfig();
                        }
                    }else{
                        if(!this.isEdit&&oldVal===undefined){
                            this.getOrgSelectorList();
                        }
                    }
                },
                immediate: true,
                deep: true, // 深度监听
            },
        },
        mounted() {
            console.log('mounted ad_org');
            if(this.isEdit) {
                let editInfo = this.$store.getters.apple_edit_info
                console.log('editInfo', editInfo.org_id)
                // 获取编辑状态下的详情
                this.getEditInfo(editInfo);
            }else {
                // let date = new Date(new Date().getTime()-1000*60*60*24);
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                this.formItem.startDate = `${year}-${month}-${day}`;

                this.formItem.buyer_email = this.email;
                this.formItem.buyer_name = this.name;
                // this.getOrgSelectorList();
            }

            document.addEventListener('click', this.handleDocumentClick);
            window.scrollTo(0, 0);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleDocumentClick);
        },
        methods: {
            handleDocumentClick(e){
                // console.log(e);
                this.appPopover = false;
                this.appList = [];
            },
            checkApp(item){
                console.log('checkApp', item);
                this.formItem.app_id = item.value;
                this.formItem.app_name = item.label;
                this.appInput = item.label+'【'+item.value+'】';
                this.appPopover = false;
                this.changeSelect('app_id',item.value);
            },
            removeApp(){
                this.$confirm('Modifying the App, [Ad Placement Location] [Country or Region] will be reset', 'Prompt', {
                    closeOnPressEscape:false,
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    type: 'warning',
                    callback:(action)=>{
                        console.log('action',action,this);
                        if(action=='confirm'){
                            this.formItem.app_id = '';
                            this.formItem.app_name = '';
                            this.appInput = '';
                            this.changeSelect('app_id','');
                            this.resetData('app_id');
                        }

                    },
                });
            },
            appInputChange(){
                this.$nextTick(()=>{
                    this.$refs.orgForm.clearValidate('app_id');
                });
            },
            searchApp(){
                if(this.appInput.length<3){
                    this.appList = [];
                    this.appErrTxt = 'The name or ID keyword entered cannot be less than three characters';
                }else{
                    this.appErrTxt = '';
                    this.remoteAppLoading = true;
                    this.appPopover = true;
                    this.appList = [];
                    this.$refs.orgForm.clearValidate('app_id');
                    API.getPromotionAppOptions({
                        search:this.appInput,
                        org_id:this.formItem.org_id||'',
                    }).then(res=>{
                        let resData = res.data||[];
                        this.appList = resData.map(item=>{
                            return {
                                value:item.adam_id,
                                label:item.app_name,
                            }
                        });
                        this.remoteAppLoading = false;
                    },err=>{
                        console.log('getOrgSelectorList err',err);
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.appList = [];
                        this.remoteAppLoading = false;
                    });
                }
            },
            getEditInfo(data){
                this.editLoading = true;
                this.$emit('postresult', {loading: true, dialog: false, success: false,});
                API.getCampaignInfo({
                    org_id:data.org_id,
                    campaign_id:data.campaign_id,
                }).then(res=>{
                    console.log('editCampaign',res);
                    this.editLoading = false;

                    let resData = res.data||{};
                    this.formItem.org_id = resData.org_id;
                    this.formItem.campaign_id = resData.campaign_id;
                    this.formItem.app_id = resData.adam_id;
                    this.formItem.app_name = resData.app_name;
                    this.appInput = resData.app_name+'【'+resData.adam_id+'】';
                    this.appList = [{
                        value:resData.adam_id,
                        label:resData.app_name,
                    }];
                    this.orgList = [{
                        value:resData.org_id,
                        label:resData.org_name,
                    }];

                    this.formItem.supply_source = resData.supply_source;
                    this.getPromotionAppEligibility().then(()=>{
                        this.updateEligibility();
                        this.formItem.countries_or_regions = Object.keys(resData.countries_or_regions);
                    });

                    this.formItem.daily_budget = resData.daily_budget;
                    this.getOrgConfig();
                    this.formItem.campaign_name = resData.campaign_name;

                    let startTime = resData.start_time||'';
                    let endTime = resData.end_time||'';

                    this.startEndDateType = endTime?'2':'1';
                    this.formItem.startDate = startTime.split(' ')[0]||'';
                    this.formItem.startTime = startTime.split(' ')[1]||'';
                    if(endTime){
                        this.formItem.endDate = endTime.split(' ')[0]||'';
                        this.formItem.endTime = endTime.split(' ')[1]||'';
                    }

                    this.formItem.client_name = resData.client_name;
                    this.formItem.order_number = resData.order_number;
                    this.formItem.buyer_name = resData.buyer_name;
                    this.formItem.buyer_email = resData.buyer_email;
                    this.formItem.billing_contact_email = resData.billing_contact_email||'';
                    this.getCampaignDailyBudgetConfig();
                    this.$emit('postresult', {loading: false, dialog: false, success: false,});

                },err=>{
                    console.log('editCampaign err',err);
                    this.editLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$emit('postresult', {loading: false, dialog: false, success: false,});
                })
            },
            changeSelect(type,val){
                console.log('changeSelect',type,val);

                if(!this.oldSelectVal[type]){
                    this.oldSelectVal[type] = this.formItem[type];
                    if(type=='app_id'){
                        this.resetData(type);
                        this.$emit('postresult', {loading: false, dialog: !!this.formItem.app_id, success: false})
                    }else if(type=='org_id'){
                        this.getCampaignDailyBudgetConfig();
                        // this.getOrgConfig();
                        let orgItem = this.orgList.find(item=>item.value==val)||{};
                        this.orgName = orgItem.label||'';
                        console.log('val1', val, this.orgList)
                        this.$emit('postOrg', {
                            id: val ? val : '',
                            list: this.orgList
                        })
                        this.$emit('postresult', {loading: false, dialog: !!this.formItem.app_id, success: false})
                    }
                }else if(val!=this.oldSelectVal[type]){
                    if(type=='org_id'&&this.formItem.app_id){
                        this.$confirm('Modifying the campaign group will clear all entered content', 'Prompt', {
                            closeOnPressEscape:false,
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: 'Confirm',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                        }).then(() => {
                            console.log('resetData',type);
                            this.oldSelectVal.app_id = '';
                            this.resetData('org_id');
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();
                            this.oldSelectVal[type] = this.formItem[type];
                            this.appInput = '';
                            this.formItem.app_id = '';
                            this.formItem.app_name = '';
                            this.formItem.daily_budget = '';
                            this.avgCampaignDailyBudget = '';
                            this.getOrgConfig();
                            this.getCampaignDailyBudgetConfig();

                            console.log('修改1', val, this.orgList)
                            this.$emit('postOrg', {
                                id: val ? val : '',
                                list: this.orgList
                            })

                        }).catch(() => {
                            this.formItem[type] = this.oldSelectVal[type];
                            console.log('修改2 取消', val, this.oldSelectVal[type], this.orgList)
                            this.$emit('postOrg', {
                                id: this.oldSelectVal[type] ? this.oldSelectVal[type] : '',
                                list: this.orgList
                            })
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();

                            
                        });
                    }else if(type=='app_id'&&val){
                        this.$confirm('Modifying the App, [Ad Placement Location] [Country or Region] will be reset', 'Prompt', {
                            closeOnPressEscape:false,
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: 'Confirm',
                            cancelButtonText: 'Cancel',
                            type: 'warning',
                        }).then(() => {
                            console.log('resetData',type);
                            this.formItem.app_id = val;
                            this.oldSelectVal.app_id = val;
                            this.resetData('app_id');
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();
                            let orgItem = this.orgList.find(item=>item.value==this.formItem.org_id)||{};
                            this.orgName = orgItem.label||'';
                            this.oldSelectVal[type] = this.formItem[type];
                        }).catch(() => {
                            this.formItem[type] = this.oldSelectVal[type];
                            /*手动隐藏下拉筛选框*/
                            this.$refs['select_'+type].blur();
                        });
                    }else{
                        this.oldSelectVal[type] = this.formItem[type];
                        if(type=='org_id'&&val){
                            console.log('val2', val, this.orgList)
                            this.formItem.daily_budget = '';
                            this.$emit('postOrg', {
                                id: val ? val : '',
                                list: this.orgList
                            })
                            this.getOrgConfig();
                            this.getCampaignDailyBudgetConfig();
                        }
                    }
                }else{
                    this.oldSelectVal[type] = this.formItem[type];
                }
            },
            resetData(type){
                if(type=='org_id'){
                    this.formItem.app_id = '';
                    this.avgCampaignDailyBudget = 0;
                    this.oldSelectVal.app_id = '';
                    this.resetData('app_id');
                }else if(type=='app_id'){
                    this.getPromotionAppEligibility();
                    if(this.formItem.app_id){
                        let appItem = this.appList.find(item=>item.value==this.formItem.app_id);
                        this.formItem.order_number = this.formItem.app_id;
                        this.formItem.client_name = appItem?appItem.label:'';
                    }
                    this.formItem.supply_source = '';
                    this.formItem.countries_or_regions = [];
                    this.countryList = [];
                    this.appList = [];
                    this.formItem.negative_keyword = [];
                }
            },
            getOrgConfig(){
                API.getOrgConfig({
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.orgConfig.currency = resData.currency;
                    this.orgConfig.invoicing_options = resData.invoicing_options;

                    this.formItem.time_zone = resData.time_zone;

                    /* 编辑的时候拿getEditInfo接口里的值，此处仅添加时需要赋值 */
                    if(!this.isEdit){
                        this.formItem.billing_contact_email = resData.billing_contact_email||'';
                    }
                })
            },
            getCampaignDailyBudgetConfig(){
                API.getCampaignDailyBudgetConfig({
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    let resData = res.data||{};
                    this.avgCampaignDailyBudget = +resData.avg_campaign_daily_budget;
                })
            },
            getPromotionAppEligibility(){
                let appId = this.formItem.app_id;
                if(!appId) {
                    this.supplySourceOptions.forEach(item=>{
                        item.disabled = true;
                        item.popTip = 'Please select an app first';
                    });
                    return false;
                }

                this.appEligibilityLoading = true;
                return API.getPromotionAppEligibility({
                    adam_id:this.formItem.app_id,
                    org_id:this.formItem.org_id,
                }).then(res=>{
                    console.log('getPromotionAppEligibility',res);

                    let resData = res.data||{};
                    this.appEligibility = resData;
                    this.supplySourceOptions.forEach(item=>{
                           let actionItem = resData[item.name];
                           item.title = actionItem.name;
                           item.desc = actionItem.note;
                           item.disabled = actionItem.state!='ELIGIBLE';
                           item.popTip = actionItem.state=='ELIGIBLE'?'':'The app you selected is temporarily not available for placement in this location';
                       });
                    this.appEligibilityLoading = false;
                },err=>{
                    console.log('getPromotionAppEligibility err',err);
                    this.appEligibilityLoading = false;
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'Request Failed');
                })
            },
            getOrgSelectorList(){
                this.remoteOrgLoading = true;
                API.getOrgSelectorList({
                    source_page:this.cur_tab_page,
                    search:'',
                }).then(res=>{
                    let resData = res.data||[];
                    let resultList = resData.map(item=>{
                        return {
                            value:item.org_id,
                            label:item.org_name,
                        }
                    });
                    this.$emit('postOrg', {
                        id: '',
                        list: resultList
                    })
                    this.remoteOrgLoading = false;
                },err=>{
                    console.log('getOrgSelectorList err',err);
                    // this.orgList = [];
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$emit('postOrg', {
                        id: '',
                        list: []
                    })
                    this.remoteOrgLoading = false;
                })
            },
            remoteAppMethod(query){
                if (query.length >3) {
                    this.remoteAppLoading = true;
                    API.getPromotionAppOptions({
                        search:query,
                        org_id:this.formItem.org_id||'',
                    }).then(res=>{
                        let resData = res.data||[];
                        this.appList = resData.map(item=>{
                            return {
                                value:item.adam_id,
                                label:item.app_name,
                            }
                        });
                        this.remoteAppLoading = false;
                    },err=>{
                        console.log('getOrgSelectorList err',err);
                        this.appList = [];
                        this.remoteAppLoading = false;
                        if (err.code == '403') {
                            this.$confirm(err.info||'Request Error', 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                    })

                } else {
                    this.appList = [];
                }
            },
            changeSupplySource(val){
                console.log('changeSupplySource',val);

                if(this.formItem.supply_source=='APPSTORE_SEARCH_RESULTS'&&this.formItem.negative_keyword.length>0){
                    this.$confirm('Modify the delivery location, added negative keywords will be cleared?', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.formItem.negative_keyword = [];
                        this.formItem.supply_source = val;
                        this.updateEligibility();
                    }).catch(() => {

                    });

                }else{
                    this.formItem.supply_source = val;
                    this.updateEligibility();
                }

                this.$refs.orgForm.validateField('supply_source');
            },
            updateEligibility(){
                let supply_source = this.formItem.supply_source;
                if(!supply_source) return;
                let actionItem = this.appEligibility[supply_source]||{};
                let listObj = actionItem.country_or_region||{};
                let keyList = Object.keys(listObj)||[];
                this.countryList = keyList.map(item=>{
                    return {
                        label:listObj[item],
                        value:item,
                    }
                });
                this.formItem.countries_or_regions = [];
            },
            handleDailyBudgetInput(val,limit=2){
                let rval = val.replace(/[^0-9\d.]/g, ''); //保留数字

                // rval = rval.replace(/^00/, "0."); //开头不能有两个0
                rval = rval.replace(/^\./g, "0."); //开头为小数点转换为0.
                rval = rval.replace(/\.{2,}/g, "."); //两个以上的小数点转换成一个
                rval = rval.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."); //只保留一个小数点
                /^0\d+/.test(rval) ? rval = rval.slice(1) : ''; //两位以上数字开头不能为0
                // rval = rval.replace(/[^0-9\d.]/g, '').replace(/^(-)?0(?!\.)/g, '')
                const str = '^(\\d+)\\.(\\d{' + limit + '}).*$'
                const reg = new RegExp(str)
                if (limit === 0) {
                    // 不需要小数点
                    rval = rval.replace(reg, '$1')
                } else {
                    // 通过正则保留小数点后指定的位数
                    rval = rval.replace(reg, '$1.$2')
                }
                this.formItem.daily_budget = rval;
            },
            showNegativeKeywordModal(){
                this.$refs.negativeKeywordModal.showModal();
            },
            clearNegativeKeyword(){
                this.formItem.negative_keyword = [];
            },
            saveNegativeKeyword(list){
                this.formItem.negative_keyword = [...list];
            },
            handleSubmit(name, type,toGroup){
                this.$refs.orgForm.validate((valid) => {
                    if(valid){
                        let reqData = {
                            org_id:this.formItem.org_id,
                            supply_source:this.formItem.supply_source,
                            adam_id:this.formItem.app_id,
                            countries_or_regions:this.formItem.countries_or_regions,
                            campaign_name:this.formItem.campaign_name,
                            daily_budget:this.formItem.daily_budget,
                            start_time:this.formItem.startDate+' '+this.formItem.startTime,
                            time_zone:this.formItem.time_zone,
                        };

                        /* 搜索结果：有否定关键词，其他选项没有 */
                        if(this.formItem.supply_source=='APPSTORE_SEARCH_RESULTS'&&!this.isEdit){
                            let negativeKeyword = this.formItem.negative_keyword.map(item=>{
                                return {
                                    text:item.key_word_text,
                                    match_type:item.match_type=='Exact Match'?'EXACT':(item.match_type=='Broad Match'?'BROAD':''),
                                }
                            });
                            reqData.negative_keyword = JSON.stringify(negativeKeyword);
                        }

                        if(this.startEndDateType=='2'){
                            reqData.end_time = this.formItem.endDate+' '+this.formItem.endTime;
                        }else if(this.startEndDateType=='1'){
                            reqData.end_time = '';
                        }
                        if(this.orgConfig.invoicing_options){
                            reqData.client_name = this.formItem.client_name;
                            reqData.order_number = this.formItem.order_number;
                            reqData.buyer_name = this.formItem.buyer_name;
                            reqData.buyer_email = this.formItem.buyer_email;
                            reqData.billing_contact_email = this.formItem.billing_contact_email;
                        }


                        this.$emit('postresult', {loading: true, dialog: false, success: false, type:type})

                        let currency_time = new Date().valueOf();
                        let current_name = `${this.apple_create_type}_${currency_time}`;
                        if(this.apple_create_type == 'editOrg') {
                            reqData.campaign_id = this.formItem.campaign_id;

                            this.dialogVisible = true;
                            this.dialogTypeTitle = 'Edit Campaign， processing…';

                            API.editCampaign(reqData).then(res=>{
                                console.log('editCampaign',res);
                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''

                                // 单个请求成功
                                let flag_single_post_html = get_flag_suc_html(res['info'], '')
                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 5000,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_single_post_html
                                });

                                this.$emit('postresult', {loading: false, dialog: false, success: true,type:'editOrg'})

                            },err=>{
                                console.log('editCampaign err',err);
                                let resultData = err.data||{};

                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''
                                if (err.code == '403') {
                                    this.$confirm(err.info, 'Prompt', {
                                        confirmButtonText: 'Refresh',
                                        cancelButtonText: 'Close',
                                        type: 'warning',
                                        showClose: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {
                                    });
                                    return
                                }



                                // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                                let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'],[],[],current_name );

                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 0,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_mul_err_html
                                });
                                this.$store.commit('apple/ADD_NOTIFY', {
                                    id: `${current_name}_close`,
                                    value: current_tip,
                                });

                                this.$emit('postresult', {loading: false, dialog: false, success: false,type:type})
                            })
                        }else {
                            this.dialogVisible = true;
                            this.dialogTypeTitle = 'Create Campaign，processing…';

                            API[name](reqData, {
                                timeout: 120 * 1000,
                            }).then(res => {
                                console.log('提交', res)
                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''

                                // 单个请求成功
                                let flag_single_post_html = get_flag_suc_html(res['info'], '')
                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 5000,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_single_post_html
                                });

                                if(toGroup){
                                    let resData = res.data||{};
                                    let campData = resData.data||{};
                                    let campaignList = [{
                                        campaign_id:campData.campaign_id,
                                        campaign_name:campData.campaign_name,
                                    }];

                                    this.$emit('postresult', {loading: false, dialog: false, success: true,type:type,toGroup:!!toGroup,campaign_list:{type:'campaign',list:campaignList}})
                                }else{
                                    this.$emit('postresult', {loading: false, dialog: false, success: true,type:type})
                                }
                            }, err => {
                                let resultData = err.data||{};
                                // 处理多个个请求中 关闭
                                this.dialogVisible = false
                                this.dialogTypeTitle = ''
                                if (err.code == '403') {
                                    this.$confirm(err.info, 'Prompt', {
                                        confirmButtonText: 'Refresh',
                                        cancelButtonText: 'Close',
                                        type: 'warning',
                                        showClose: false,
                                        closeOnClickModal: false,
                                        closeOnPressEscape: false
                                    }).then(() => {
                                        window.location.reload()
                                    }).catch(() => {
                                    });
                                    return
                                }

                                let campData = resultData.data||{};
                                let isCreateCampSuccess = campData.campaign_id&&campData.campaign_name;

                                let keywordErrList = resultData.keyword_err_list||[];
                                let negativeKeywordErrList = resultData.negative_keyword_err_list||[];


                                // 处理多个错误结果 info, msg,errList,negativeErrList,current_name
                                let flag_mul_err_html = get_create_ad_err_html(err['info'], resultData['msg'], keywordErrList, negativeKeywordErrList,current_name );

                                let current_tip = this.$notify({
                                    showClose: false,
                                    duration: 0,
                                    dangerouslyUseHTMLString: true,
                                    message: flag_mul_err_html
                                });
                                this.$store.commit('apple/ADD_NOTIFY', {
                                    id: `${current_name}_close`,
                                    value: current_tip,
                                });


                                if(toGroup&&isCreateCampSuccess){
                                    let campaignList = [{
                                        campaign_id:campData.campaign_id,
                                        campaign_name:campData.campaign_name,
                                    }];
                                    this.$emit('postresult', {loading: false, dialog: false, success: true,type:type,toGroup:!!toGroup,campaign_list:{type:'campaign',list:campaignList}})
                                }else{
                                    this.$emit('postresult', {loading: false, dialog: false, success: false,type:type})
                                }
                            })
                        }
                    }else{
                        console.log('error submit!!');
                        this.$message.error('Form data contains errors. Please check and resubmit');
                        return false;
                    }
                });
            },
        },

    }
    
</script>
<style lang="scss" scoped>
    .width80{
        width: 80px;
    }
    .width400 {
        width: 400px;
    }
    .normal-text{
        font-size: 12px;
        color: #606266;
    }

    .apple_org ::v-deep .el-form-item__label{
        text-indent: 20px;
    }
    .apple_org ::v-deep .invoicing_options .el-form-item__label{
        text-indent: 10px;
    }

    .create_list{
        background-color: #fff;
        padding: 10px;
        margin-bottom: 20px;
        .create_title{
            font-size: 14px;
            padding-bottom: 10px;
            padding-left: 20px;
        }
        .create_item{
            display: flex;
            align-items: center;
            padding-bottom: 30px;
            .create_label{
                flex: 0 0 200px;
                .star{
                    color: #ff0000;
                    font-size: 16px;
                    display: inline-block;
                    vertical-align: middle;
                }
                .create_label_text{
                    font-size: 14px;
                    display: inline-block;
                }
            }
            .create_action{
                flex: 0 0 300px;
                position: relative;
                .create_err_bottom{
                    color: #ff0000;
                    position: absolute;
                }
            }
            .create_err_right{
                flex: auto;
                display: inline-block;
                color: #ff0000;
            }
            .questions {
                width: 12px;
                height: 12px;
                line-height: 14px;
                text-align: center;
                border-radius: 10px;
                background-color: #333;
                color: #fff;
                font-size: 12px;
                display: inline-block;
                margin-left: 2px;
                cursor: pointer;
            }
            .ad_name_flex{
                display: flex;
                align-items:center;
                .num_length{
                    padding-left:8px;
                    flex: 0 0 60px;
                }
            }
        }

        .daily-budget-tips-text{
            position: absolute;
            left: 420px;
            right: 0;
            line-height: 16px;
            top: 8px;
        }
    }

    .app-reference{
        position: absolute;
        display: block;
        width: 10px;
        height: 1px;
        top: 30px;
        z-index: 3;
    }
    .remove-app-btn{
        display: block;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        position: absolute;
        cursor: pointer;
        top: 6px;
        left: 295px;
        z-index: 1;
        &:hover{
            color: #333;
            background-color: #fff;
        }


    }
</style>
